import { Component, Input, OnInit, Output,EventEmitter,SimpleChanges, ViewChild, OnChanges, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { DistributionListDetails } from 'app/views/campaign-3/models/campaign-3.model';

@Component({
  selector: 'app-campaign-3-view-distribution-list-details',
  templateUrl: './campaign-3-view-distribution-list-details.component.html',
  styleUrls: ['./campaign-3-view-distribution-list-details.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3ViewDistributionListDetailsComponent implements OnInit {
  
  @Input() distributionListDetails: Array<DistributionListDetails>;

  @Input() distributionListId: number = null;
  
  customFilter = Campaign3KontableComponent.CustomFilter;
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  show = {
    table: false
  }

  
  constructor(
    public srvCampaign3: Campaign3Service
    ) {
  
  }
  ngOnInit() {
    if(this.distributionListId>0){
      this.srvCampaign3.distributionListId = this.distributionListId.toString();
    }
    this.show.table = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/view-distribution-list-details/campaign-3-view-distribution-list-details.component.ts